import { fromJS } from 'immutable';
import { ApiUrl5, UserToken } from '../../../helper/HelperAuth'
import { GetTicketDay } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (body) => async (dispatch, getState) => {

    const Authorization = UserToken;
    const url = ApiUrl5 + 'total-tickets-by-day';
    const argument = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': Authorization,
        },
        body: JSON.stringify(body)
    };

    const response = await doFetch(url, argument);
    var data = fromJS({});
    if (response.ok) {
        data = fromJS(await response.json());
        data = data.get("total-tickets")
        var x = []
        for (var i = 0; i < data.size; i++) {
            var datinti = data.get(i)
            var hari = ((datinti.get("hari")).substring(0,1)).toUpperCase()+
        (datinti.get("hari")).substring(1,3)
            var obj = { name: hari}
            obj["total-tickets"] = parseInt(datinti.get("total-tickets"))
            x.push(obj)

        }
        data=x 
    }
    dispatch({ type: GetTicketDay, data:fromJS(data)});
    return data
};